import IBModuleApi from "../../api/iuviBankingAPI";
import { urlContexts } from "../../constants";

export const getVersions = async () => {
  const { data } = await IBModuleApi.get(
    `${process.env.REACT_APP_BACKEND_HOST}/${urlContexts.console}/rest/1.0/cs/version`
  );

  return data;
};

export const createVersions = async (createInfo: any) => {
  const { data } = await IBModuleApi.post(
    `${process.env.REACT_APP_BACKEND_HOST}/${urlContexts.console}/rest/1.0/cs/version`,
    createInfo
  );

  return data;
};

export const updateVersions = async (updateInfo: any) => {
  const { data } = await IBModuleApi.put(
    `${process.env.REACT_APP_BACKEND_HOST}/${urlContexts.console}/rest/1.0/cs/version`,
    updateInfo,
    {
      headers: {
      lang: localStorage.getItem('LANGUAGE')
      }
    }
  );

  return data;
};

export const deleteVersion = async (versionId: number) => {
  const { data } = await IBModuleApi.delete(
    `${process.env.REACT_APP_BACKEND_HOST}/${urlContexts.console}/rest/1.0/cs/version/${versionId}`
  );

  return data;
};
